(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ls-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-slider-next]').forEach(function (btn) {
      var id     = btn.dataset.sliderNext;
      var slider = document.getElementById('ls-slider-' + id);
      if (!slider) return;
      var track = slider.querySelector('#ls-track-' + id);
      var dots  = slider.querySelectorAll('[data-slider-dot="' + id + '"]');
      var total = dots.length;
      var cur   = 0;
      var timer;

      function goTo(n) {
        cur = ((n % total) + total) % total;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === cur);
          d.setAttribute('aria-selected', i === cur ? 'true' : 'false');
        });
      }
      function next()  { goTo(cur + 1); }
      function prev()  { goTo(cur - 1); }
      function start() { if (total > 1) timer = setInterval(next, 5000); }
      function stop()  { clearInterval(timer); }

      btn.addEventListener('click', function () { stop(); next(); start(); });

      var prevBtn = slider.querySelector('[data-slider-prev="' + id + '"]');
      if (prevBtn) prevBtn.addEventListener('click', function () { stop(); prev(); start(); });

      dots.forEach(function (d) {
        d.addEventListener('click', function () { stop(); goTo(+d.dataset.slide); start(); });
      });

      /* Touch / swipe */
      var tx = 0;
      slider.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend',   function (e) {
        var dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) { stop(); dx < 0 ? next() : prev(); start(); }
      }, { passive: true });

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
